'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _formatName = require('I18n/utils/formatName');

var _formatName2 = _interopRequireDefault(_formatName);

var _components = require('I18n/components');

var _UITruncateString = require('UIComponents/text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

var _UISelectableBox = require('UIComponents/button/UISelectableBox');

var _UISelectableBox2 = _interopRequireDefault(_UISelectableBox);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _enums = require('MeetingsLib/constants/enums');

var _colors = require('HubStyleTokens/colors');

var _color = require('MeetingsBase/utils/color');

var _color2 = require('MeetingsLib/utils/color');

var _Branding = require('MeetingsBase/models/Branding');

var _Branding2 = _interopRequireDefault(_Branding);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'TimePickerButton',

  propTypes: {
    branding: _react.PropTypes.instanceOf(_Branding2.default).isRequired,
    disabled: _react.PropTypes.bool,
    handleSetEventDateTime: _react.PropTypes.func.isRequired,
    isFetchingPublicGlobalBranding: _react.PropTypes.bool.isRequired,
    ownerEmail: _react.PropTypes.string,
    ownerFirstName: _react.PropTypes.string,
    ownerLastName: _react.PropTypes.string,
    relatedEventStartTime: _react.PropTypes.number,
    selectedTime: _react.PropTypes.number,
    time: _react.PropTypes.number.isRequired,
    unavailableReason: _react.PropTypes.string,
    userTimezone: _react.PropTypes.string.isRequired
  },

  getInitialState: function getInitialState() {
    return { hover: false };
  },
  onMouseEnter: function onMouseEnter() {
    this.setState({ hover: true });
  },
  onMouseLeave: function onMouseLeave() {
    this.setState({ hover: false });
  },
  getBrandingActiveStyle: function getBrandingActiveStyle() {
    var _props = this.props,
        isFetchingPublicGlobalBranding = _props.isFetchingPublicGlobalBranding,
        primaryColor = _props.branding.primaryColor,
        time = _props.time,
        selectedTime = _props.selectedTime;
    var hover = this.state.hover;

    if (!hover && time !== selectedTime) {
      return null;
    }

    var colorToUse = isFetchingPublicGlobalBranding ? _colors.EERIE : primaryColor;

    return {
      borderColor: colorToUse,
      backgroundColor: (0, _color2.getColorStyleWithOpacity)(colorToUse)
    };
  },
  getBrandingTextStyle: function getBrandingTextStyle() {
    var _props2 = this.props,
        isFetchingPublicGlobalBranding = _props2.isFetchingPublicGlobalBranding,
        primaryColor = _props2.branding.primaryColor;


    if (isFetchingPublicGlobalBranding) {
      return { color: _colors.EERIE };
    }

    if (!primaryColor) {
      return null;
    }

    return { color: (0, _color.getPrimaryColorOrDefault)(primaryColor) };
  },
  getOwnerName: function getOwnerName() {
    var _props3 = this.props,
        ownerFirstName = _props3.ownerFirstName,
        ownerLastName = _props3.ownerLastName,
        ownerEmail = _props3.ownerEmail;

    var formattedName = (0, _formatName2.default)({
      firstName: ownerFirstName,
      lastName: ownerLastName
    });
    return formattedName || ownerEmail;
  },
  getUnavailableMessageProps: function getUnavailableMessageProps() {
    var _props4 = this.props,
        unavailableReason = _props4.unavailableReason,
        relatedEventStartTime = _props4.relatedEventStartTime;

    var ownerName = this.getOwnerName();

    switch (unavailableReason) {
      case _enums.UNAVAILABLE_REASONS.PAST:
        return { message: 'troubleshoot.past' };
      case _enums.UNAVAILABLE_REASONS.ALL_DAY_EVENT:
        return { message: 'troubleshoot.allDayBusy', options: { ownerName: ownerName } };
      case _enums.UNAVAILABLE_REASONS.EVENT:
        return { message: 'troubleshoot.busy', options: { ownerName: ownerName } };
      case _enums.UNAVAILABLE_REASONS.BUFFER:
        return {
          message: 'troubleshoot.buffer',
          options: {
            relatedEventStartTime: this.getLowercaseTime(relatedEventStartTime)
          }
        };
      case _enums.UNAVAILABLE_REASONS.MINIMUM_NOTICE:
        return { message: 'troubleshoot.minimumNotice' };
      default:
        return { message: 'troubleshoot.default' };
    }
  },
  getLowercaseTime: function getLowercaseTime(timestamp) {
    var userTimezone = this.props.userTimezone;


    var timeOfDay = _I18n2.default.moment(timestamp).tz(userTimezone).format('LT');
    return timeOfDay.toLowerCase();
  },
  renderUnavailableReason: function renderUnavailableReason() {
    var disabled = this.props.disabled;


    if (!disabled) {
      return null;
    }

    var text = _react2.default.createElement(_components.FormattedReactMessage, this.getUnavailableMessageProps());

    return _react2.default.createElement(
      _UITruncateString2.default,
      {
        tooltip: _react2.default.createElement(
          _Small2.default,
          null,
          text
        )
      },
      _react2.default.createElement(
        _Small2.default,
        { use: 'help' },
        text
      )
    );
  },
  renderMinutes: function renderMinutes() {
    var time = this.props.time;


    var lowerCaseTimeOfDay = this.getLowercaseTime(time);
    return _react2.default.createElement(
      'span',
      { style: this.getBrandingTextStyle() },
      lowerCaseTimeOfDay
    );
  },
  render: function render() {
    var _props5 = this.props,
        disabled = _props5.disabled,
        handleSetEventDateTime = _props5.handleSetEventDateTime,
        selectedTime = _props5.selectedTime,
        time = _props5.time;


    return _react2.default.createElement(
      'div',
      { className: 'p-y-1 p-right-1' },
      _react2.default.createElement(
        _UISelectableBox2.default,
        {
          disabled: disabled,
          block: true,
          padded: false,
          className: 'time-picker-btn',
          selected: selectedTime === time,
          style: this.getBrandingActiveStyle(),
          onMouseEnter: this.onMouseEnter,
          onMouseLeave: this.onMouseLeave,
          onClick: handleSetEventDateTime
        },
        this.renderMinutes(),
        _react2.default.createElement('br', null),
        this.renderUnavailableReason()
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/schedule/time/TimePickerButton.js
// module id = 444
// module chunks = 0